export default {"src":"/_next/static/media/notecard_cli.347e1461.svg","height":256,"width":556,"blurWidth":0,"blurHeight":0};